// Page-notes events shared by the toolbar and the app top bar. No 'agentation' import and no API calls here,
// so the top bar can use it without loading the toolbar.
export type BatchTarget = { batchId: string; tab: 'sent' | 'seen' | 'fixed' | 'rejected' };
export const PN_OPEN_BATCH = 'pn:open-batch';

/**
 * Which My-notes batch a page_note_update row is about: the batch id rides in the link (`pnBatch=`), the tab
 * comes from the status in sourceEventId (`page-note-<noteId>-<status>-<ms>-<userId>`; open → Sent).
 */
export function bellTarget(r: { link?: string | null; sourceEventId?: string | null }): BatchTarget | null {
  // SUN-105: "<admin> did not send your note" opens My notes → Rejected (no batch to expand)
  if (/[?&]pnTab=rejected(&|#|$)/.test(r.link ?? '')) return { batchId: '', tab: 'rejected' };
  const m = /[?&]pnBatch=([^&#]+)/.exec(r.link ?? '');
  const s = /^page-note-[^-]+-(open|seen|fixed)-/.exec(r.sourceEventId ?? '');
  if (!m || !s) return null;
  return { batchId: decodeURIComponent(m[1]!), tab: s[1] === 'open' ? 'sent' : (s[1] as 'seen' | 'fixed') };
}

/** Ask the page-notes toolbar (if it is on the page) to open My notes on a batch. True when it took it. */
export function openMyNotesOnBatch(target: BatchTarget): boolean {
  const detail = { target, handled: false };
  window.dispatchEvent(new CustomEvent(PN_OPEN_BATCH, { detail }));
  return detail.handled;
}
